import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Define NavMenu here
export const NavMenu = ({ onLogout }) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-end mb-6">
      <div>
        <button onClick={() => navigate('/links')} className="text-cyan-400 hover:text-cyan-500 mr-4">Partner Links</button>
        <button onClick={() => navigate('/history')} className="text-cyan-400 hover:text-cyan-500 mr-4">History</button>
        <a href="/instructions.html" className="text-cyan-400 hover:text-cyan-500 mr-4">Instructions</a>
        <button onClick={onLogout} className="text-cyan-400 hover:text-cyan-500">Logout</button>
      </div>
    </div>
  );
};

function Links({ user, setUser, showToast }) {
  const [links, setLinks] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('xlinkSeoLimit');
    setUser(null);
    showToast('Logged out');
    navigate('/');
  };

  useEffect(() => {
    console.log('Attempting to fetch /links.json');
    fetch('/links.json', { cache: 'no-store' })
      .then(res => {
        console.log('Fetch response:', res);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status} - ${res.statusText}`);
        return res.json();
      })
      .then(data => {
        console.log('Raw data from links.json:', data);
        if (!Array.isArray(data)) {
          throw new Error('links.json is not an array');
        }
        setLinks(data);
        console.log('Links state updated:', data);
        setError(null);
      })
      .catch(err => {
        console.error('Fetch error:', err.message);
        setError(`Failed to load partner links: ${err.message}`);
      });
  }, []);

  const leftColumn = links.filter((_, i) => i % 2 === 0);
  const rightColumn = links.filter((_, i) => i % 2 !== 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-purple-900 flex flex-col items-center">
      <div className="w-full max-w-4xl p-8 text-white">
        <NavMenu onLogout={logout} />
        <div className="mt-8 p-8 bg-white bg-opacity-10 backdrop-blur-lg rounded-xl shadow-lg">
          <h1 className="text-3xl font-bold text-cyan-300 mb-8 text-center" style={{ fontFamily: "'Orbitron', sans-serif" }}>
            Partner Links
          </h1>
          {error ? (
            <p className="text-red-400 text-center">{error}</p>
          ) : (
            <div className="flex gap-8 justify-center flex-wrap">
              <div className="flex-1 min-w-[350px] p-4">
                <h2 className="font-bold text-cyan-400 text-xl text-center mb-4">Our Partners</h2>
                {leftColumn.length > 0 ? (
                  leftColumn.map((link, i) => (
                    <p key={i} className="text-left">
                      <a href={link} target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-white">
                        {link}
                      </a>
                    </p>
                  ))
                ) : (
                  <p className="text-left">No partners yet in left column.</p>
                )}
              </div>
              <div className="flex-1 min-w-[350px] p-4">
                <h2 className="font-bold text-cyan-400 text-xl text-center mb-4">Our Partners</h2>
                {rightColumn.length > 0 ? (
                  rightColumn.map((link, i) => (
                    <p key={i} className="text-left">
                      <a href={link} target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-white">
                        {link}
                      </a>
                    </p>
                  ))
                ) : (
                  <p className="text-left">No partners yet in right column.</p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Links;
